/* **************************************************** Kitchen collections */
export interface FSKitchenCollection {
    id: number;
    kitchen_collection_name: string;
}

export const mapFSKitchenCollection = (data: any): FSKitchenCollection => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const res: FSKitchenCollection = {
        id: data.id,
        kitchen_collection_name: data.kitchen_collection_name
    };

    return res;
};

export const mapFSKitchenCollections = (data: any[]): FSKitchenCollection[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }

    return data.map(mapFSKitchenCollection);
};